import Mutations from '../../odata/mutations';

export default { ...new Mutations('skillSet'), ...new Mutations('skillSets') };
